import React, { useState } from "react";
import "./PhotoGallery2026Styles.css";
import Footer from "../../../Components/FooterItems/Footer";
import image1 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_001.jpg";
import image2 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_002.jpg";
import image3 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_003.jpg";
import image4 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_004.jpg";
import image5 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_005.jpg";
import image6 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_006.jpg";
import image7 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_007.jpg";
import image8 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_008.jpg";
import image9 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_009.jpg";
import image10 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_010.jpg";
import image11 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_011.jpg";
import image12 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_012.jpg";
import image13 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_013.jpg";
import image14 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_014.jpg";
import image15 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_015.jpg";
import image16 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_016.jpg";
import image17 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_017.jpg";
import image18 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_018.jpg";
import image19 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_019.jpg";
import image20 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_020.jpg";
import image21 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_021.jpg";
import image22 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_022.jpg";
import image23 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_023.jpg";
import image24 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_024.jpg";
import image25 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_025.jpg";
import image26 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_026.jpg";
import image27 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_027.jpg";
import image28 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_028.jpg";
import image29 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_029.jpg";
import image30 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_030.jpg";
import image31 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_031.jpg";
import image32 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_032.jpg";
import image33 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_033.jpg";
import image34 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_034.jpg";
import image35 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_035.jpg";
import image36 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_036.jpg";
import image37 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_037.jpg";
import image38 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_038.jpg";
import image39 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_039.jpg";
import image40 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_040.jpg";
import image41 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_041.jpg";
import image42 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_042.jpg";
import image43 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_043.jpg";
import image44 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_044.jpg";
import image45 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_045.jpg";
import image46 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_046.jpg";
import image47 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_047.jpg";
import image48 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_048.jpg";
import image49 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_049.jpg";
import image50 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_050.jpg";
import image51 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_051.jpg";
import image52 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_052.jpg";
import image53 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_053.jpg";
import image54 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_054.jpg";
import image55 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_055.jpg";
import image56 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_056.jpg";
import image57 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_057.jpg";
import image58 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_058.jpg";
import image59 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_059.jpg";
import image60 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_060.jpg";
import image61 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_061.jpg";
import image62 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_062.jpg";
import image63 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_063.jpg";
import image64 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_064.jpg";
import image65 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_065.jpg";
import image66 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_066.jpg";
import image67 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_067.jpg";
import image68 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_068.jpg";
import image69 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_069.jpg";
import image70 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_070.jpg";
import image71 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_071.jpg";
import image72 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_072.jpg";
import image73 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_073.jpg";
import image74 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_074.jpg";
import image75 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_075.jpg";
import image76 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_076.jpg";
import image77 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_077.jpg";
import image78 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_078.jpg";
import image79 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_079.jpg";
import image80 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_080.jpg";
import image81 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_081.jpg";
import image82 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_082.jpg";
import image83 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_083.jpg";
import image84 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_084.jpg";
import image85 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_085.jpg";
import image86 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_086.jpg";
import image87 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_087.jpg";
import image88 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_088.jpg";
import image89 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_089.jpg";
import image90 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_090.jpg";
import image91 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_091.jpg";
import image92 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_092.jpg";
import image93 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_093.jpg";
import image94 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_094.jpg";
import image95 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_095.jpg";
import image96 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_096.jpg";
import image97 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_097.jpg";
import image98 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_098.jpg";
import image99 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_099.jpg";
import image100 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_100.jpg";
import image101 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_101.jpg";
import image102 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_102.jpg";
import image103 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_103.jpg";
import image104 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_104.jpg";
import image105 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_105.jpg";
import image106 from "../../../Assets/Multimedia/PhotoGallery_2026/Poush_26_106.jpg";

const PhotoGallery2026 = () => {
  // Array to hold image file paths
  const images = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
    image9,
    image10,
    image11,
    image12,
    image13,
    image14,
    image15,
    image16,
    image17,
    image18,
    image19,
    image20,
    image21,
    image22,
    image23,
    image24,
    image25,
    image26,
    image27,
    image28,
    image29,
    image30,
    image31,
    image32,
    image33,
    image34,
    image35,
    image36,
    image37,
    image38,
    image39,
    image40,
    image41,
    image42,
    image43,
    image44,
    image45,
    image46,
    image47,
    image48,
    image49,
    image50,
    image51,
    image52,
    image53,
    image54,
    image55,
    image56,
    image57,
    image58,
    image59,
    image60,
    image61,
    image62,
    image63,
    image64,
    image65,
    image66,
    image67,
    image68,
    image69,
    image70,
    image71,
    image72,
    image73,
    image74,
    image75,
    image76,
    image77,
    image78,
    image79,
    image80,
    image81,
    image82,
    image83,
    image84,
    image85,
    image86,
    image87,
    image88,
    image89,
    image90,
    image91,
    image92,
    image93,
    image94,
    image95,
    image96,
    image97,
    image98,
    image99,
    image100,
    image101,
    image102,
    image103,
    image104,
    image105,
    image106,
  ];

  const [isModalOpen, setIsModalOpen] = useState(false); // State for modal open/close
  const [currentImageIndex, setCurrentImageIndex] = useState(0); // Index for current image in modal

  // Open modal and set the selected image
  const openModal = (index) => {
    setIsModalOpen(true);
    setCurrentImageIndex(index);
  };

  // Close modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Go to the next image
  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  // Go to the previous image
  const prevImage = () => {
    setCurrentImageIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length,
    );
  };

  return (
    <div className="PhotoGallery-container">
      <h1>POUSH MELA PHOTO GALLERY 2026</h1>
      {/* Display the image thumbnails in a grid */}
      <div className="photo_gallery">
        {images.map((image, index) => (
          <div
            className="thumbnail"
            key={index}
            onClick={() => openModal(index)}
          >
            <img src={image} alt={`thumbnail-${index}`} />
          </div>
        ))}
      </div>

      {/* Modal for image enlargement */}
      {isModalOpen && (
        <div className="photo-modal">
          <button className="photo-close" onClick={closeModal}>
            ×
          </button>

          <button className="photo-arrow photo-prev" onClick={prevImage}>
            ❮
          </button>

          <img
            src={images[currentImageIndex]}
            alt={`modal-img-${currentImageIndex}`}
            className="photo-modal-image"
          />

          <button className="photo-arrow photo-next" onClick={nextImage}>
            ❯
          </button>
        </div>
      )}
      <Footer />
    </div>
  );
};

export default PhotoGallery2026;
